import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IZipCode } from '../../models/zipcode.interface';

@Injectable({
  providedIn: 'root'
})
export abstract class ZipCodeApiService {

  abstract get(): Observable<IZipCode[]>;

  abstract getDetailed(): Observable<IZipCode[]>;

}